// extracted by mini-css-extract-plugin
module.exports = {"Certificates":"certificates_Certificates__Z7U0p","Name":"certificates_Name__JSYeL","Link":"certificates_Link__ueOys"};